import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotRecommendSection from './components/HotRecommendSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '073漫画网 - 免费韩漫大全',
    url: 'http://heiliaoapp.cn/',
    description: '073漫画网提供韩国漫画无删减下拉式阅读服务，免费韩漫大全资源齐全、持续更新。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://heiliaoapp.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '073漫画网',
    url: 'http://heiliaoapp.cn/',
    description: '韩国漫画无删减下拉式在线阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@heiliaoapp.cn',
      contactType: 'customer service',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '073漫画网的韩国漫画都是无删减版本吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，我们平台上的所有韩国漫画均为无删减完整版。我们与韩方版权方深度合作，确保每一部漫画都原汁原味地呈现给读者。',
        },
      },
      {
        '@type': 'Question',
        name: '什么是下拉式阅读？如何使用？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '下拉式阅读是专为移动端优化的漫画阅读方式，整个章节纵向连续排列，只需上下滑动屏幕即可流畅阅读。',
        },
      },
      {
        '@type': 'Question',
        name: '073漫画网的韩漫资源多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们坚持每日更新，大部分热门连载漫画在韩文版更新后24-48小时内同步上线中文翻译版本。',
        },
      },
      {
        '@type': 'Question',
        name: '073漫画网完全免费吗？需要注册吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全免费！无需注册登录，无需支付任何费用，打开网站即可开始阅读。',
        },
      },
      {
        '@type': 'Question',
        name: '网站支持哪些设备阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '采用响应式设计，完美支持PC电脑端、平板电脑和手机浏览器。手机端专为竖屏优化，单手持握即可浏览。',
        },
      },
      {
        '@type': 'Question',
        name: '如何搜索我想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '可通过网站顶部搜索框直接搜索漫画名称或作者名，也可按分类浏览发现感兴趣的漫画。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画中出现加载问题怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '请检查网络连接、刷新页面或清除浏览器缓存后重新访问。我们使用了CDN加速技术确保快速加载。',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://heiliaoapp.cn/',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <HotRecommendSection />
          <LatestUpdatesSection />
          <CTASection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}